import { render, staticRenderFns } from "./edit-employee.vue?vue&type=template&id=e0aef4f4"
import script from "./edit-employee.vue?vue&type=script&lang=js"
export * from "./edit-employee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports